export default "__VITE_ASSET__5fL_YFfH__"